<template >
  <div name="documents">
    <div class="table-wrapper">
      <div v-if="errored" class="empty">
        <p>
          We are not able to retrieve this information at the moment, please try
          back later
        </p>
      </div>

  
      <div id="content-area" v-else>
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Videos</p>
      </div>

      <div v-else>
        <table
          class="
            w-full
            mx-auto
            mb-2
            h-10
            pt-2
            align-text-bottom
            bg-white
            rounded
            text-left text-gray-600
          "
        >
          <thead class="bg-gray-100 w-full">
            <tr>
              <th class="w-1 pl-10"></th>
              <th class="w-9/12 pl-3">Title</th>
              <th w-1 ></th>
            </tr>
          </thead>
        </table>

        <table class="table-wrapper w-full bg-white mx-auto rounded shadow-sm">
          <tbody>
            <tr v-for="(video, index) in filteredList" :key="video.id">
              <td
                    class="w-1 px-4 text-left"
                  >
                    <i class="fas fa-video opacity-75"></i>
                  </td>
              <td class="w-10/12 font-semibold">{{ video.title }}</td>
              <td class="2u text-left">
                <a
                  @click="display(video)"
                  class="text-xs cursor-pointer pr-4 text-blue-400"
                    v-if="shouldDisplay(index)"
                  >View</a
                >
                <i v-else class="fas fa-lock text-yellow-500 text-lg"></i>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="m-4 text-gray-500 pt-2 pl-5">
          Showing {{ filteredList.length }} videos
        </div>
      </div>
    </div>
</div>
    <modalvideo
      :url="loadVideoPath()"
      @close="showModalVideo = false"
      v-if="selectedVideo != undefined && showModalVideo"
      v-show="showModalVideo"
    ></modalvideo>
  </div>

</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { BaseService } from "@/services/school.service";

const modalvideo = () => import("@/components/ModalVideo.vue");


export default {
  name: "videos",
  props: {
    type: { type: Object, required: true },
    searchValue: { type: String, required: false},
    hasAccess: { type: Boolean, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.videos.length > 0;
    },
    orderedVideos() {
      return _.orderBy(this.videos, ["title"]);
    },
    filteredList() {
      var vm = this;
      return this.orderedVideos.filter((item) => {
        let filtered = true;

        if (filtered && vm.searchValue != undefined) {
          if (item.title != null) {
            filtered = item.title
              .toLowerCase()
              .includes(vm.searchValue.toLowerCase());
          }
        }

        return filtered;
      });
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      videos: [],
      selectedVideo: {},
      showModalVideo: false,
      currentTab: 0,
    };
  },
  watch: {
    '$props':{
      handler: function (val, oldVal) { 
        this.fetchData()
      },
      deep: true
    }
  },
  created() {
    this.fetchData();
  },
  mounted() {
  },
  methods: {
    fetchData() {
      this.loading = true;

      BaseService.getAll("videos?types=library&tags=" + this.type.value)
        .then((response) => this.buildVideoList(response.data.data))
        .catch((err) => {
          console.log("Videos " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildVideoList(data) {
      this.videos = data;
    },
    display(video) {
      this.selectedVideo = video;
      this.showModalVideo = true;
    },
    loadVideoPath() {
      return this.selectedVideo.service_url_b;
    },
    setStyles(value) {
      return this.vid === value
        ? "bg-orange-300 text-white"
        : "bg-white text-gray-400";
    },
    checkTab(value) {
      return this.currentTab == value ? "active" : "";
    },
    showVideos(tab, cat) {
      this.typeSelected = "videos";
      this.currentTab = tab;
      this.videoType = cat;
    },
    updateVideoType(value) {
      this.videoType = value;
      this.fetchData()
    },
    setSearchValue(value) {
      this.search = value
    },
    parseTypeDisplay(value) {
      return value.toLowerCase()
    },
    shouldDisplay(index) {
      if (index === 0) {
        return true
      } else if (this.currentUser.isOnTrial) {
        return false
      } else if (this.currentUser.isSubscriber && this.hasAccess) {
        return true
      }
    }
  },
  components: {
    modalvideo,
  },
};
</script>

<style>
i.icon {
  font-size: 18px;
  padding-left: 4px;
  padding-top: 4px;
}
</style>


